<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	import { navigate } from 'svelte-navaid';
	// Constants
	import { EventStatus } from '@/Constants/Event.js';
	import { Sport } from '@/Constants/Sport.js';
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	import MeetingStore from '@/Stores/Racing/MeetingStore.js';
	import { ntjFilter } from '@/Stores/Store.js';
	import PreferenceStore from '@/Stores/PreferenceStore.js';
	// Components
	import FontIcon from '@/Components/FontIcon.svelte';
	import Icon from '@/Components/Icon.svelte';

	dayjs.extend(localizedFormat);

	export let selectedMeetingId;

	let totalItems = 12;

	function onClickRace(race) {
		navigate(`/racing/meetings/${race.meeting_id}/races/${race.id}`);
	}

	function getMeetingName(race) {
		let meeting = $MeetingStore.firstWhere('id', race.meeting_id);
		return meeting ? meeting.name : '';
	}

	function onFilterClick(sport) {
		ntjFilter.update((items) => {
			let index = items.indexOf(sport);
			if (index >= 0) {
				items.splice(index, 1);
			} else {
				items.push(sport);
			}

			return items;
		});
	}
</script>

<div class="flex">
	<div class="flex flex-col mr-2 space-y-1 text-light-grey">
		<button
			on:click={() => onFilterClick(Sport.Gallop)}
			class:text-light={$ntjFilter.indexOf(Sport.Gallop) >= 0}
			class="p-1 rounded bg-dark-grey hover:bg-grey focus:outline-none"
		>
			<FontIcon icon="gallop" />
		</button>
		<button
			on:click={() => onFilterClick(Sport.Harness)}
			class:text-light={$ntjFilter.indexOf(Sport.Harness) >= 0}
			class="p-1 rounded bg-dark-grey hover:bg-grey focus:outline-none"
		>
			<FontIcon icon="harness" />
		</button>
		<button
			on:click={() => onFilterClick(Sport.Greyhound)}
			class:text-light={$ntjFilter.indexOf(Sport.Greyhound) >= 0}
			class="p-1 rounded bg-dark-grey hover:bg-grey focus:outline-none"
		>
			<FontIcon icon="greyhound" />
		</button>
		<button
			title="Show Closed"
			on:click={() => PreferenceStore.updateSetting('racing.ntjShowClosed', !$PreferenceStore.racing.ntjShowClosed)}
			class:text-light={$PreferenceStore.racing.ntjShowClosed}
			class="flex items-center justify-center rounded bg-dark-grey hover:bg-grey focus:outline-none"
		>
			<Icon name="time" classes="py-0.5" />
		</button>
	</div>
	<div class="flex flex-col flex-wrap h-40">
		{#each $RaceStore
			.whereIn('race_type.id', $ntjFilter)
			.whereIn( 'status.id', [EventStatus.Open, EventStatus.ReOpened, $PreferenceStore.racing.ntjShowClosed ? EventStatus.Closed : ''] )
			.sortBy('start_time')
			.take(totalItems)
			.all() as race (race.id)}
			<div
				on:click={() => race && onClickRace(race)}
				class:bg-orange-300={selectedMeetingId === race.meeting_id}
				class:border-red-500={race.status.id === EventStatus.Closed}
				class="flex w-48 px-2 py-1 mb-1 mr-3 text-xs border border-gray-400 cursor-pointer hover:bg-gray-200"
			>
				<FontIcon icon={race.race_type.name.toLowerCase()} className="mr-1" />
				<div class="mr-1 font-semibold whitespace-nowrap">
					{dayjs(race.start_time).format('LT')}
				</div>
				<div class="truncate">R{race.race_number} - {getMeetingName(race)}</div>
			</div>
		{/each}
	</div>
</div>
